export default __webpack_public_path__ + "media/zurb/img/work/tcl/tcl-sketch-10615c165ff0c0cc70f29df268eafc65.png";